/**
 * @fileoverview Announcement tag utilities.
 * Provides helper functions for tag slug generation and color selection
 * for announcement categorization and display.
 * @module helperMethods/announcement/index
 */

/**
 * Converts a tag string to a URL-friendly slug format.
 * Lowercases, trims, and replaces spaces with hyphens.
 *
 * @param {string} tag - Tag string to convert
 * @returns {string} URL-friendly slug
 *
 * @example
 * getTagSlug('Product Updates');
 * // Returns: "product-updates"
 *
 * @example
 * getTagSlug('  Feature Release  ');
 * // Returns: "feature-release"
 */
export const getTagSlug = (tag: string): string => {
  return tag.toLowerCase().trim().split(" ").join("-");
};

/**
 * Returns a random color from a predefined color palette.
 * Used for announcement tag background colors.
 *
 * @returns {string} Hex color code
 *
 * @example
 * const color = getRandomColorFromColors();
 * // Returns: "#D6F5FF" or "#D1DEF7"
 */
export const getRandomColorFromColors = (): string => {
  const colorArray = ["#D6F5FF", "#D1DEF7"];
  return colorArray[Math.floor(Math.random() * colorArray.length)];
};
